var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header_fix"},[_c('nav',{staticClass:"navbar"},[_c('a',{staticClass:"navbar-brand mr-auto ml-0 new_logo_well",attrs:{"href":"/"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":require("@/assets/images/logo.png"),"alt":""}})])])])
}]

export { render, staticRenderFns }